export const SET_SAVED_CASE_NOTES_SUCCESS = "SET_SAVED_CASE_NOTES_SUCCESS";
export const ADD_SAVED_CASE_NOTE_SUCCESS = "ADD_SAVED_CASE_NOTE_SUCCESS";
export const DELETE_SAVED_CASE_NOTE_SUCCESS = "DELETE_SAVED_CASE_NOTE_SUCCESS";
